import updateConversationRelations from '../../utils/updateConversationRelations';
import TableView from 'owa-mail-list-store/lib/store/schema/TableView';
import listViewStore from 'owa-mail-list-store/lib/store/Store';
import { getRowIdsFromRowKeys, getItemIdsToUpdateForFlagOperation } from 'owa-mail-list-store';
import FlagType from 'owa-service/lib/contract/FlagType';
import { ObservableMap } from 'mobx';
import { action, select } from 'satcheljs/lib/legacy';

export interface ApplyConversationFlagInListViewStoreState {
    tableViews: ObservableMap<string, TableView>;
}

/**
 * Apply flag state on the conversations in list view store
 * @param rowKeys for the conversations
 * @param flagType the flag type to apply
 * @param tableViewId the table view id
 * @param state the ApplyConversationFlagInListViewStore state used for this action
 */
export default select<ApplyConversationFlagInListViewStoreState>({
    tableViews: () => listViewStore.tableViews,
})(
    action('ApplyConversationFlagInListViewStore')(function applyConversationFlag(
        rowKeys: string[],
        flagType: FlagType,
        tableViewId: string,
        state?: ApplyConversationFlagInListViewStoreState
    ) {
        if (!flagType || !flagType.FlagStatus) {
            throw new Error('Invalid flag type.');
        }

        // Gather the item ids to be updated by going through each conversation
        const tableView = state.tableViews.get(tableViewId);
        const itemIdsToUpdate = getItemIdsToUpdateForFlagOperation(flagType, rowKeys, tableView);

        // Update the tableConversationRelation in all table views of the current folder
        const rowIdStrings = getRowIdsFromRowKeys(rowKeys, tableView.id);
        updateConversationRelations(
            rowIdStrings,
            tableView.serverFolderId,
            itemIdsToUpdate,
            (relation, itemId) => {
                relation.flagStatus = flagType.FlagStatus;
            }
        );
    })
);
